import { supabase } from '@/core/database/supabase';
import { permissionEngine } from '@/core/permissions';

export const equipmentRequestsEditService = {
  async updateRequest(userId: string, id: string, data: any) {
    await permissionEngine.assert(userId, 'equipment.requests.update', { 
      companyId: data.companyId,
      projectId: data.projectId 
    });
    
    const { error: reqError } = await supabase
      .from('equipment_requests')
      .update({
        title: data.title,
        description: data.description,
        project_id: data.projectId,
        needed_from: data.neededFrom,
        needed_until: data.neededUntil || null,
        priority: data.priority,
        updated_at: new Date().toISOString(),
      })
      .eq('id', id);

    if (reqError) throw reqError;

    // Delete old items and insert new ones
    await supabase.from('equipment_request_items').delete().eq('request_id', id);

    if (data.items && data.items.length > 0) {
      const { error: itemsError } = await supabase
        .from('equipment_request_items')
        .insert(
          data.items.map((item: any) => ({
            request_id: id,
            equipment_type_id: item.equipmentTypeId,
            quantity: item.quantity,
            note: item.note,
          }))
        );

      if (itemsError) throw itemsError;
    }
  }
};
